// Use env in Docker/local; fallback for legacy build
export const API_URL = process.env.REACT_APP_API_URL || 'https://vapp-backend.azurewebsites.net/';

/** Rahoitusluotsi chat widget — off unless REACT_APP_ENABLE_CHAT is 1/true/yes/on (build-time in CRA). */
function readChatEnabled() {
  const v = process.env.REACT_APP_ENABLE_CHAT;
  if (v === undefined || v === null || String(v).trim() === '') {
    return false;
  }
  return /^(1|true|yes|on)$/i.test(String(v).trim());
}

export const CHAT_ENABLED = readChatEnabled();

// Used when CHAT_ENABLED; external chat API base URL
export const CHAT_API_URL = process.env.REACT_APP_CHAT_API_URL || 'https://vapp-backend.azurewebsites.net/';
